/**
 * Lumiskin Conversion Optimization - Konsolide JS
 * ================================================
 * Tüm dönüşüm optimizasyonu özelliklerini tek bir dosyada toplar.
 *
 * Marka: Lumiskin
 * Ürün: Vücut Şekillendirici Masaj Cihazı
 *
 * Kapsam:
 *  1. Scroll takibi
 *  2. Geri sayım mantığı
 *  3. Rastgele izleyici sayısı
 *  4. Çıkış niyeti tespiti
 *  5. Satın alma bildirimleri
 *  6. Dinamik teslimat tarihi
 *
 * Kullanım:
 * assets/lumiskin-conversion.js olarak oluşturun.
 *
 * theme.liquid içerisinde </body> etiketinden önce ekleyin:
 * {{ 'lumiskin-conversion.js' | asset_url | script_tag }}
 */

(function (window, document) {
  'use strict';

  /* =========================================================
     AYARLAR
  ========================================================= */

  var LUMISKIN_CONFIG = {
    brandName: 'Lumiskin',
    productName: 'Vücut Şekillendirici Masaj Cihazı',
    toastColor: '#2563EB',
    toastIconBackground: '#EFF6FF',
    deliveryColor: '#2563EB',
    countdownHours: 3,
    deliveryDays: 2,
    shippingCutoffHour: 14,
    exitPopupCookieDays: 7,
    mobileExitPopupDelay: 30000,
    toastDisplayDuration: 4000,
    toastInitialDelayMin: 5000,
    toastInitialDelayMax: 10000,
    toastNextDelayMin: 15000,
    toastNextDelayMax: 35000
  };


  /* =========================================================
     YARDIMCI FONKSİYONLAR
  ========================================================= */

  /**
   * Cookie okur.
   */
  function getCookie(name) {
    var parts = document.cookie.split('; ');

    for (var i = 0; i < parts.length; i++) {
      var pair = parts[i].split('=');

      if (decodeURIComponent(pair[0]) === name) {
        return decodeURIComponent(pair[1] || '');
      }
    }

    return null;
  }


  /**
   * Cookie oluşturur.
   */
  function setCookie(name, value, days) {
    var expires = '';

    if (days) {
      var date = new Date();

      date.setTime(
        date.getTime() +
        days * 24 * 60 * 60 * 1000
      );

      expires = '; expires=' + date.toUTCString();
    }

    document.cookie =
      encodeURIComponent(name) +
      '=' +
      encodeURIComponent(value) +
      expires +
      '; path=/; SameSite=Lax';
  }


  /**
   * HTML içeriğini güvenli hale getirir.
   */
  function escapeHTML(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }


  /**
   * Belirtilen iki sayı arasında rastgele değer üretir.
   */
  function randomBetween(min, max) {
    return Math.floor(
      Math.random() * (max - min + 1)
    ) + min;
  }


  /**
   * Türk para formatı.
   *
   * Örnek:
   * 199900 kuruş → 1.999,00 TL
   */
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');

    parts[0] = parts[0].replace(
      /\B(?=(\d{3})+(?!\d))/g,
      '.'
    );

    return parts.join(',') + ' TL';
  }


  var TR_DAYS = [
    'Pazar',
    'Pazartesi',
    'Salı',
    'Çarşamba',
    'Perşembe',
    'Cuma',
    'Cumartesi'
  ];


  var TR_MONTHS = [
    'Ocak',
    'Şubat',
    'Mart',
    'Nisan',
    'Mayıs',
    'Haziran',
    'Temmuz',
    'Ağustos',
    'Eylül',
    'Ekim',
    'Kasım',
    'Aralık'
  ];


  /**
   * Başlangıç tarihine iş günü ekler.
   * Cumartesi ve pazar günlerini atlar.
   */
  function addBusinessDays(fromDate, businessDays) {
    var date = new Date(fromDate.getTime());
    var daysAdded = 0;

    while (daysAdded < businessDays) {
      date.setDate(date.getDate() + 1);

      var dayOfWeek = date.getDay();

      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        daysAdded++;
      }
    }

    return date;
  }


  /**
   * Tarihi Türkçe olarak biçimlendirir.
   *
   * Örnek:
   * Pazartesi, 5 Ocak
   */
  function formatDateTR(date) {
    return (
      TR_DAYS[date.getDay()] +
      ', ' +
      date.getDate() +
      ' ' +
      TR_MONTHS[date.getMonth()]
    );
  }


  /**
   * Sayfanın ürün sayfası olup olmadığını kontrol eder.
   */
  function isProductPage() {
    return (
      document.body.classList.contains('template-product') ||
      document.querySelector('[data-page-type="product"]') !== null ||
      document.querySelector('.product-template') !== null ||
      document.querySelector('.product__title') !== null ||
      document.querySelector('product-info') !== null ||
      window.location.pathname.indexOf('/products/') !== -1
    );
  }


  /* =========================================================
     1. SCROLL TAKİBİ
  ========================================================= */

  var LumiskinScroll = {
    ticking: false,
    handlers: [],

    init: function () {
      var self = this;

      window.addEventListener(
        'scroll',
        function () {
          if (!self.ticking) {
            window.requestAnimationFrame(function () {
              self.notifyHandlers();
              self.ticking = false;
            });

            self.ticking = true;
          }
        },
        {
          passive: true
        }
      );
    },

    onScroll: function (handler) {
      if (typeof handler === 'function') {
        this.handlers.push(handler);
      }
    },

    notifyHandlers: function () {
      var scrollY =
        window.scrollY ||
        window.pageYOffset ||
        0;

      for (var i = 0; i < this.handlers.length; i++) {
        try {
          this.handlers[i](scrollY);
        } catch (error) {
          console.error(
            'Lumiskin scroll hatası:',
            error
          );
        }
      }
    }
  };


  LumiskinScroll.init();


  /**
   * Sticky sepete ekle alanını yönetir.
   */
  function initStickyATC() {
    var stickyBar = document.getElementById(
      'lumiskin-sticky-atc'
    );

    var mainAtcButton = document.querySelector(
      [
        '[data-add-to-cart]',
        '.product-form__submit',
        '#AddToCart',
        '[name="add"]',
        '.btn--add-to-cart',
        'button[type="submit"][name="add"]'
      ].join(',')
    );

    if (!stickyBar || !mainAtcButton) {
      return;
    }

    function updateStickyBar() {
      var rect =
        mainAtcButton.getBoundingClientRect();

      var shouldShow =
        rect.bottom < 0 ||
        rect.top > window.innerHeight;

      stickyBar.classList.toggle(
        'is-visible',
        shouldShow
      );

      stickyBar.setAttribute(
        'aria-hidden',
        String(!shouldShow)
      );
    }

    LumiskinScroll.onScroll(updateStickyBar);

    updateStickyBar();
  }


  /* =========================================================
     2. GERİ SAYIM ZAMANLAYICISI
  ========================================================= */

  /**
   * Geri sayım başlatır.
   */
  function initCountdown(
    elementId,
    durationHours,
    storageKey
  ) {
    var timerElement =
      document.getElementById(elementId);

    if (!timerElement) {
      return null;
    }

    var now = Date.now();
    var endTime;
    var storedTime;

    try {
      storedTime =
        sessionStorage.getItem(storageKey);
    } catch (error) {
      storedTime = null;
    }

    if (
      storedTime &&
      parseInt(storedTime, 10) > now
    ) {
      endTime = parseInt(storedTime, 10);
    } else {
      endTime =
        now +
        durationHours *
        60 *
        60 *
        1000;

      try {
        sessionStorage.setItem(
          storageKey,
          String(endTime)
        );
      } catch (error) {
        console.warn(
          'Lumiskin sayaç kaydedilemedi.'
        );
      }
    }

    function pad(number) {
      return number < 10
        ? '0' + number
        : String(number);
    }

    function tick() {
      var remaining = Math.max(
        0,
        endTime - Date.now()
      );

      if (remaining === 0) {
        endTime =
          Date.now() +
          durationHours *
          60 *
          60 *
          1000;

        try {
          sessionStorage.setItem(
            storageKey,
            String(endTime)
          );
        } catch (error) {
          console.warn(
            'Lumiskin sayaç yenilenemedi.'
          );
        }

        remaining =
          durationHours *
          60 *
          60 *
          1000;
      }

      var totalSeconds =
        Math.floor(remaining / 1000);

      var hours =
        Math.floor(totalSeconds / 3600);

      var minutes =
        Math.floor(
          (totalSeconds % 3600) / 60
        );

      var seconds =
        totalSeconds % 60;

      timerElement.textContent =
        pad(hours) +
        ':' +
        pad(minutes) +
        ':' +
        pad(seconds);
    }

    tick();

    return window.setInterval(
      tick,
      1000
    );
  }


  /**
   * Sayfadaki tüm Lumiskin sayaçlarını başlatır.
   *
   * Örnek HTML:
   * <span id="lumiskin-timer-1" data-hours="3"></span>
   */
  function initAllCountdowns() {
    var countdownElements =
      document.querySelectorAll(
        '[id^="lumiskin-timer-"]'
      );

    countdownElements.forEach(
      function (element) {
        var sectionId =
          element.id.replace(
            'lumiskin-timer-',
            ''
          );

        var storageKey =
          'lumiskin_countdown_end_' +
          sectionId;

        var hours =
          parseInt(
            element.getAttribute(
              'data-hours'
            ) ||
            LUMISKIN_CONFIG.countdownHours,
            10
          );

        if (
          isNaN(hours) ||
          hours <= 0
        ) {
          hours =
            LUMISKIN_CONFIG.countdownHours;
        }

        initCountdown(
          element.id,
          hours,
          storageKey
        );
      }
    );
  }


  /* =========================================================
     3. RASTGELE İZLEYİCİ SAYACI
  ========================================================= */

  /**
   * Ürünü inceleyen kişi sayısını günceller.
   *
   * Örnek HTML:
   * <span id="lumiskin-viewer-count-1"></span>
   */
  function initViewerCount() {
    var viewerElements =
      document.querySelectorAll(
        '[id^="lumiskin-viewer-count-"]'
      );

    viewerElements.forEach(
      function (element) {
        var minimum =
          parseInt(
            element.getAttribute(
              'data-min'
            ) || '8',
            10
          );

        var maximum =
          parseInt(
            element.getAttribute(
              'data-max'
            ) || '24',
            10
          );

        if (isNaN(minimum)) {
          minimum = 8;
        }

        if (isNaN(maximum)) {
          maximum = 24;
        }

        if (maximum < minimum) {
          maximum = minimum;
        }

        var current =
          randomBetween(
            minimum,
            maximum
          );

        element.textContent = current;

        window.setInterval(
          function () {
            var delta =
              Math.random() < 0.5
                ? -1
                : 1;

            current = Math.max(
              minimum,
              Math.min(
                maximum,
                current + delta
              )
            );

            element.textContent =
              current;
          },
          randomBetween(
            8000,
            15000
          )
        );
      }
    );
  }


  /* =========================================================
     4. ÇIKIŞ NİYETİ POPUP
  ========================================================= */

  var EXIT_COOKIE =
    'lumiskin_exit_popup_shown';


  function initExitIntent() {
    var popup =
      document.getElementById(
        'lumiskin-exit-popup'
      );

    if (!popup) {
      return;
    }

    if (getCookie(EXIT_COOKIE)) {
      return;
    }

    var triggered = false;


    function showPopup() {
      if (triggered) {
        return;
      }

      triggered = true;

      popup.classList.add('is-open');

      popup.setAttribute(
        'aria-hidden',
        'false'
      );

      document.body.style.overflow =
        'hidden';

      setCookie(
        EXIT_COOKIE,
        '1',
        LUMISKIN_CONFIG.exitPopupCookieDays
      );

      var firstFocusableElement =
        popup.querySelector(
          'input, button, a, select, textarea'
        );

      if (firstFocusableElement) {
        window.setTimeout(
          function () {
            firstFocusableElement.focus();
          },
          350
        );
      }
    }


    function closePopup() {
      popup.classList.remove('is-open');

      popup.setAttribute(
        'aria-hidden',
        'true'
      );

      document.body.style.overflow =
        '';
    }


    document.addEventListener(
      'mouseleave',
      function (event) {
        if (event.clientY <= 0) {
          showPopup();
        }
      }
    );


    var isMobile =
      /Mobi|Android|iPhone|iPad/i.test(
        navigator.userAgent
      );

    if (isMobile) {
      window.setTimeout(
        showPopup,
        LUMISKIN_CONFIG.mobileExitPopupDelay
      );
    }


    var closeButton =
      document.getElementById(
        'lumiskin-ep-close'
      );

    var backdrop =
      document.getElementById(
        'lumiskin-ep-backdrop'
      );

    var declineButton =
      document.getElementById(
        'lumiskin-ep-decline'
      );


    if (closeButton) {
      closeButton.addEventListener(
        'click',
        closePopup
      );
    }

    if (backdrop) {
      backdrop.addEventListener(
        'click',
        closePopup
      );
    }

    if (declineButton) {
      declineButton.addEventListener(
        'click',
        closePopup
      );
    }


    document.addEventListener(
      'keydown',
      function (event) {
        if (
          event.key === 'Escape' &&
          popup.classList.contains(
            'is-open'
          )
        ) {
          closePopup();
        }
      }
    );
  }


  /* =========================================================
     5. SATIN ALMA BİLDİRİMLERİ
  ========================================================= */

  var TOAST_MESSAGES = [
    {
      name: 'Ayşe K.',
      city: 'İstanbul',
      product:
        'Lumiskin Vücut Şekillendirici Masaj Cihazı',
      time: 2
    },
    {
      name: 'Zeynep T.',
      city: 'Ankara',
      product:
        'Lumiskin Vücut Şekillendirici Masaj Cihazı',
      time: 5
    },
    {
      name: 'Elif S.',
      city: 'İzmir',
      product:
        'Lumiskin Vücut Şekillendirici Masaj Cihazı',
      time: 8
    },
    {
      name: 'Merve A.',
      city: 'Bursa',
      product:
        'Lumiskin Vücut Şekillendirici Masaj Cihazı',
      time: 3
    },
    {
      name: 'Fatma D.',
      city: 'Antalya',
      product:
        'Lumiskin Vücut Şekillendirici Masaj Cihazı',
      time: 12
    },
    {
      name: 'Seda Y.',
      city: 'Konya',
      product:
        'Lumiskin Vücut Şekillendirici Masaj Cihazı',
      time: 1
    },
    {
      name: 'Ebru K.',
      city: 'Adana',
      product:
        'Lumiskin Vücut Şekillendirici Masaj Cihazı',
      time: 7
    },
    {
      name: 'Selin Ö.',
      city: 'Gaziantep',
      product:
        'Lumiskin Vücut Şekillendirici Masaj Cihazı',
      time: 4
    },
    {
      name: 'Büşra B.',
      city: 'Kayseri',
      product:
        'Lumiskin Vücut Şekillendirici Masaj Cihazı',
      time: 10
    },
    {
      name: 'Ceren C.',
      city: 'Eskişehir',
      product:
        'Lumiskin Vücut Şekillendirici Masaj Cihazı',
      time: 6
    },
    {
      name: 'Derya G.',
      city: 'Samsun',
      product:
        'Lumiskin Vücut Şekillendirici Masaj Cihazı',
      time: 9
    },
    {
      name: 'Gizem P.',
      city: 'Kocaeli',
      product:
        'Lumiskin Vücut Şekillendirici Masaj Cihazı',
      time: 14
    }
  ];


  /**
   * Toast CSS kodlarını ekler.
   */
  function injectToastStyles() {
    if (
      document.getElementById(
        'lumiskin-toast-styles'
      )
    ) {
      return;
    }

    var style =
      document.createElement('style');

    style.id =
      'lumiskin-toast-styles';

    style.textContent = [
      '#lumiskin-toast-container {',
      '  position: fixed;',
      '  left: 20px;',
      '  bottom: 80px;',
      '  z-index: 9998;',
      '  display: flex;',
      '  flex-direction: column;',
      '  gap: 10px;',
      '  width: calc(100% - 40px);',
      '  max-width: 340px;',
      '  pointer-events: none;',
      '}',

      '.lumiskin-toast {',
      '  position: relative;',
      '  display: flex;',
      '  align-items: center;',
      '  gap: 10px;',
      '  width: 100%;',
      '  padding: 11px 13px;',
      '  box-sizing: border-box;',
      '  background: #ffffff;',
      '  border-left: 4px solid ' +
        LUMISKIN_CONFIG.toastColor +
        ';',
      '  border-radius: 10px;',
      '  box-shadow: 0 5px 22px rgba(0, 0, 0, 0.14);',
      '  pointer-events: auto;',
      '  overflow: hidden;',
      '  animation: lumiskin-toast-in 0.35s cubic-bezier(0.34, 1.3, 0.64, 1) forwards;',
      '  will-change: transform, opacity;',
      '}',

      '.lumiskin-toast.is-leaving {',
      '  animation: lumiskin-toast-out 0.3s ease forwards;',
      '}',

      '.lumiskin-toast__icon {',
      '  flex: 0 0 36px;',
      '  width: 36px;',
      '  height: 36px;',
      '  display: flex;',
      '  align-items: center;',
      '  justify-content: center;',
      '  background: ' +
        LUMISKIN_CONFIG.toastIconBackground +
        ';',
      '  border-radius: 50%;',
      '}',

      '.lumiskin-toast__body {',
      '  flex: 1;',
      '  min-width: 0;',
      '}',

      '.lumiskin-toast__title {',
      '  margin: 0 0 1px;',
      '  color: #171717;',
      '  font-size: 12.5px;',
      '  font-weight: 700;',
      '  line-height: 1.25;',
      '  white-space: nowrap;',
      '  overflow: hidden;',
      '  text-overflow: ellipsis;',
      '}',

      '.lumiskin-toast__meta {',
      '  margin: 0;',
      '  color: #666666;',
      '  font-size: 11.5px;',
      '  font-weight: 500;',
      '  line-height: 1.25;',
      '  white-space: nowrap;',
      '  overflow: hidden;',
      '  text-overflow: ellipsis;',
      '}',

      '.lumiskin-toast__time {',
      '  margin: 2px 0 0;',
      '  color: ' +
        LUMISKIN_CONFIG.toastColor +
        ';',
      '  font-size: 11px;',
      '  font-weight: 700;',
      '  line-height: 1.2;',
      '}',

      '.lumiskin-toast__close {',
      '  flex: 0 0 auto;',
      '  width: 22px;',
      '  height: 22px;',
      '  padding: 0;',
      '  display: flex;',
      '  align-items: center;',
      '  justify-content: center;',
      '  color: #9a9a9a;',
      '  background: transparent;',
      '  border: none;',
      '  border-radius: 50%;',
      '  cursor: pointer;',
      '  font-size: 17px;',
      '  line-height: 1;',
      '}',

      '.lumiskin-toast__close:hover {',
      '  color: #222222;',
      '  background: #f3f4f6;',
      '}',

      '@keyframes lumiskin-toast-in {',
      '  from {',
      '    opacity: 0;',
      '    transform: translateX(-25px) scale(0.96);',
      '  }',
      '  to {',
      '    opacity: 1;',
      '    transform: translateX(0) scale(1);',
      '  }',
      '}',

      '@keyframes lumiskin-toast-out {',
      '  from {',
      '    opacity: 1;',
      '    transform: translateX(0) scale(1);',
      '  }',
      '  to {',
      '    opacity: 0;',
      '    transform: translateX(-25px) scale(0.96);',
      '  }',
      '}',

      '@media (max-width: 480px) {',
      '  #lumiskin-toast-container {',
      '    left: 10px;',
      '    right: 10px;',
      '    bottom: 75px;',
      '    width: auto;',
      '    max-width: none;',
      '  }',

      '  .lumiskin-toast {',
      '    padding: 10px 11px;',
      '  }',

      '  .lumiskin-toast__title {',
      '    font-size: 12px;',
      '  }',

      '  .lumiskin-toast__meta {',
      '    font-size: 11px;',
      '  }',
      '}',

      '@media (prefers-reduced-motion: reduce) {',
      '  .lumiskin-toast,',
      '  .lumiskin-toast.is-leaving {',
      '    animation-duration: 0.01ms;',
      '  }',
      '}'
    ].join('\n');

    document.head.appendChild(style);
  }


  /**
   * Toast bildirim alanını oluşturur.
   */
  function createToastContainer() {
    var existingContainer =
      document.getElementById(
        'lumiskin-toast-container'
      );

    if (existingContainer) {
      return existingContainer;
    }

    injectToastStyles();

    var container =
      document.createElement('div');

    container.id =
      'lumiskin-toast-container';

    container.setAttribute(
      'aria-live',
      'polite'
    );

    container.setAttribute(
      'aria-label',
      'Lumiskin son satın alma bildirimleri'
    );

    document.body.appendChild(
      container
    );

    return container;
  }


  /**
   * Toast bildirimini kaldırır.
   */
  function removeToast(toast) {
    if (
      !toast ||
      toast.classList.contains(
        'is-leaving'
      )
    ) {
      return;
    }

    toast.classList.add(
      'is-leaving'
    );

    window.setTimeout(
      function () {
        if (toast.parentNode) {
          toast.parentNode.removeChild(
            toast
          );
        }
      },
      300
    );
  }


  /**
   * Yeni satın alma bildirimi gösterir.
   */
  function showToast(message) {
    if (!message) {
      return;
    }

    var container =
      createToastContainer();

    var toast =
      document.createElement('div');

    toast.className =
      'lumiskin-toast';

    toast.setAttribute(
      'role',
      'status'
    );

    var name =
      escapeHTML(message.name);

    var city =
      escapeHTML(message.city);

    var product =
      escapeHTML(
        message.product ||
        LUMISKIN_CONFIG.productName
      );

    var time =
      parseInt(message.time, 10) || 1;

    toast.innerHTML = [
      '<div class="lumiskin-toast__icon" aria-hidden="true">',

      '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="' +
        LUMISKIN_CONFIG.toastColor +
        '" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">',

      '<circle cx="9" cy="21" r="1"></circle>',
      '<circle cx="20" cy="21" r="1"></circle>',
      '<path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>',
      '</svg>',
      '</div>',

      '<div class="lumiskin-toast__body">',
      '<p class="lumiskin-toast__title">' +
        name +
        ' — ' +
        city +
        '</p>',

      '<p class="lumiskin-toast__meta">' +
        product +
        ' satın aldı</p>',

      '<p class="lumiskin-toast__time">' +
        time +
        ' dakika önce</p>',
      '</div>',

      '<button type="button" class="lumiskin-toast__close" aria-label="Bildirimi kapat">×</button>'
    ].join('');

    var closeButton =
      toast.querySelector(
        '.lumiskin-toast__close'
      );

    if (closeButton) {
      closeButton.addEventListener(
        'click',
        function () {
          removeToast(toast);
        }
      );
    }

    container.appendChild(toast);

    window.setTimeout(
      function () {
        removeToast(toast);
      },
      LUMISKIN_CONFIG.toastDisplayDuration
    );
  }


  /**
   * Satın alma bildirimlerini sırayla gösterir.
   */
  function initPurchaseToasts() {
    if (!isProductPage()) {
      return;
    }

    var messageQueue =
      TOAST_MESSAGES.slice();

    for (
      var i = messageQueue.length - 1;
      i > 0;
      i--
    ) {
      var randomIndex =
        Math.floor(
          Math.random() * (i + 1)
        );

      var temporaryValue =
        messageQueue[i];

      messageQueue[i] =
        messageQueue[randomIndex];

      messageQueue[randomIndex] =
        temporaryValue;
    }

    var index = 0;

    var initialDelay =
      randomBetween(
        LUMISKIN_CONFIG.toastInitialDelayMin,
        LUMISKIN_CONFIG.toastInitialDelayMax
      );


    function showNext() {
      if (
        document.visibilityState ===
        'hidden'
      ) {
        window.setTimeout(
          showNext,
          10000
        );

        return;
      }

      if (
        index >= messageQueue.length
      ) {
        index = 0;

        for (
          var i = messageQueue.length - 1;
          i > 0;
          i--
        ) {
          var randomIndex =
            Math.floor(
              Math.random() *
              (i + 1)
            );

          var temporaryValue =
            messageQueue[i];

          messageQueue[i] =
            messageQueue[randomIndex];

          messageQueue[randomIndex] =
            temporaryValue;
        }
      }

      showToast(
        messageQueue[index]
      );

      index++;

      var nextDelay =
        randomBetween(
          LUMISKIN_CONFIG.toastNextDelayMin,
          LUMISKIN_CONFIG.toastNextDelayMax
        );

      window.setTimeout(
        showNext,
        nextDelay
      );
    }


    window.setTimeout(
      showNext,
      initialDelay
    );
  }


  /* =========================================================
     6. DİNAMİK TESLİMAT TARİHİ
  ========================================================= */

  /**
   * Teslimat tarihinin hesaplanacağı başlangıç gününü verir.
   */
  function getDeliveryStartDate() {
    var today = new Date();

    var startDate =
      new Date(today.getTime());

    if (
      today.getHours() >=
      LUMISKIN_CONFIG.shippingCutoffHour
    ) {
      startDate.setDate(
        startDate.getDate() + 1
      );
    }

    return startDate;
  }


  /**
   * Sayfadaki teslimat tarihi alanlarını günceller.
   *
   * Örnek:
   * <span class="lumiskin-delivery-date" data-delivery-days="2"></span>
   */
  function initDeliveryDates() {
    var elements =
      document.querySelectorAll(
        [
          '.lumiskin-delivery-date',
          '[data-lumiskin-delivery-date]',
          '[data-delivery-date]'
        ].join(',')
      );

    if (elements.length === 0) {
      return;
    }

    var startDate =
      getDeliveryStartDate();

    elements.forEach(
      function (element) {
        var days =
          parseInt(
            element.getAttribute(
              'data-delivery-days'
            ) ||
            LUMISKIN_CONFIG.deliveryDays,
            10
          );

        if (
          isNaN(days) ||
          days < 1
        ) {
          days =
            LUMISKIN_CONFIG.deliveryDays;
        }

        var deliveryDate =
          addBusinessDays(
            startDate,
            days
          );

        element.textContent =
          formatDateTR(
            deliveryDate
          );
      }
    );
  }


  /**
   * Teslimat mesajı kutusunu oluşturur.
   *
   * Örnek HTML:
   * <div class="lumiskin-delivery-widget"></div>
   */
  function initDeliveryWidget() {
    var widgets =
      document.querySelectorAll(
        '.lumiskin-delivery-widget'
      );

    if (widgets.length === 0) {
      return;
    }

    var today = new Date();

    var startDate =
      getDeliveryStartDate();

    var deliveryDate =
      addBusinessDays(
        startDate,
        LUMISKIN_CONFIG.deliveryDays
      );

    var deliveryString =
      formatDateTR(
        deliveryDate
      );

    var isBeforeCutoff =
      today.getHours() <
      LUMISKIN_CONFIG.shippingCutoffHour;

    var cutoffMessage =
      isBeforeCutoff
        ? 'Bugün saat ' +
          LUMISKIN_CONFIG.shippingCutoffHour +
          ':00’a kadar sipariş verin'
        : 'Şimdi sipariş verin';


    widgets.forEach(
      function (widget) {
        widget.innerHTML = [
          '<div style="display:flex;align-items:center;gap:8px;font-size:13.5px;line-height:1.35;color:#444;flex-wrap:wrap;">',

          '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="' +
            LUMISKIN_CONFIG.deliveryColor +
            '" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">',

          '<rect x="1" y="3" width="15" height="13" rx="1"></rect>',
          '<path d="M16 8h4l3 5v3h-7V8z"></path>',
          '<circle cx="5.5" cy="18.5" r="2.5"></circle>',
          '<circle cx="18.5" cy="18.5" r="2.5"></circle>',
          '</svg>',

          '<span>' +
            cutoffMessage +
            ', <strong style="color:' +
            LUMISKIN_CONFIG.deliveryColor +
            ';">' +
            deliveryString +
            '</strong> tarihinde teslim alın!</span>',

          '</div>'
        ].join('');
      }
    );
  }


  /* =========================================================
     7. SEPETE EKLE GERİ BİLDİRİMİ
  ========================================================= */

  /**
   * Sepet sayacını Shopify cart.js üzerinden günceller.
   */
  function updateCartCount() {
    fetch('/cart.js', {
      headers: {
        'X-Requested-With':
          'XMLHttpRequest'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Sepet bilgisi alınamadı.'
          );
        }

        return response.json();
      })
      .then(function (cart) {
        var cartCountElements =
          document.querySelectorAll(
            [
              '.cart-count',
              '[data-cart-count]',
              '.cart__item-count',
              '.header__cart-count',
              '.cart-count-bubble span[aria-hidden="true"]'
            ].join(',')
          );

        cartCountElements.forEach(
          function (element) {
            element.textContent =
              cart.item_count;

            if (
              cart.item_count > 0
            ) {
              element.classList.remove(
                'is-hidden',
                'hidden'
              );
            }
          }
        );
      })
      .catch(function (error) {
        console.warn(
          'Lumiskin sepet sayacı güncellenemedi:',
          error
        );
      });
  }


  document.addEventListener(
    'cart:updated',
    function () {
      var cartOpenEvent =
        new CustomEvent(
          'theme:cart:open'
        );

      document.dispatchEvent(
        cartOpenEvent
      );

      updateCartCount();
    }
  );


  document.addEventListener(
    'cart:refresh',
    updateCartCount
  );


  /* =========================================================
     SHOPIFY SEPET FORMU TAKİBİ
  ========================================================= */

  function initCartFormTracking() {
    document.addEventListener(
      'submit',
      function (event) {
        var form =
          event.target.closest(
            'form[action*="/cart/add"]'
          );

        if (!form) {
          return;
        }

        window.setTimeout(
          function () {
            updateCartCount();
          },
          1200
        );
      }
    );
  }


  /* =========================================================
     SAYFA YÜKLENDİĞİNDE TÜM MODÜLLERİ BAŞLAT
  ========================================================= */

  function init() {
    initStickyATC();
    initAllCountdowns();
    initViewerCount();
    initExitIntent();
    initPurchaseToasts();
    initDeliveryDates();
    initDeliveryWidget();
    initCartFormTracking();
  }


  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }


  /* =========================================================
     SHOPIFY THEME EDITOR DESTEĞİ
  ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function () {
      initAllCountdowns();
      initViewerCount();
      initDeliveryDates();
      initDeliveryWidget();
      initStickyATC();
    }
  );


  /* =========================================================
     PUBLIC API
  ========================================================= */

  window.Lumiskin =
    window.Lumiskin || {};

  window.Lumiskin.config =
    LUMISKIN_CONFIG;

  window.Lumiskin.formatMoney =
    formatMoney;

  window.Lumiskin.addBusinessDays =
    addBusinessDays;

  window.Lumiskin.formatDateTR =
    formatDateTR;

  window.Lumiskin.showToast =
    showToast;

  window.Lumiskin.initCountdown =
    initCountdown;

  window.Lumiskin.getCookie =
    getCookie;

  window.Lumiskin.setCookie =
    setCookie;

  window.Lumiskin.updateCartCount =
    updateCartCount;

  window.Lumiskin.productName =
    LUMISKIN_CONFIG.productName;

  window.Lumiskin.brandName =
    LUMISKIN_CONFIG.brandName;

}(window, document));